export default function replaceAllStringWithSymbol(
  initialString: string,
  symbolReplacement: string
): string {
  return String(initialString).replace(/(.)/gi, symbolReplacement);
}
